import { Injectable } from '@angular/core';
import { GroupsService } from './groups.service';

@Injectable({
  providedIn: 'root'
})
export class GroupsAdapterService {

  constructor(private __groupsService: GroupsService) { }

  public async getGroupList(idCompany: any, page: number = 0, filter?: any): Promise<any> {
    try {
      console.log("getGroupList/page", page);
      let response: any;
      if (filter) {
        response = await this.__groupsService.getGroupAll(idCompany, page, filter);
      } else {
        response = await this.__groupsService.getGroupAll(idCompany, page);
      }

      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {
            page: 0,
            pages: 1,
            count: 0,
            total: 0,
            records: []
          },
          message: 'Ocurrio un error al obtener la lista de grupos'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {
          page: 0,
          pages: 1,
          count: 0,
          total: 0,
          records: []
        },
        message: error.message
      }
    }
  }

  public async getGroupListRoot(idCompany: any): Promise<any> {
    try {
      let response: any;
      response = await this.__groupsService.getAllGroupsRoot(idCompany);
      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {
            page: 0,
            pages: 1,
            count: 0,
            total: 0,
            records: []
          },
          message: 'Ocurrio un error al obtener la lista de grupos'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {
          page: 0,
          pages: 1,
          count: 0,
          total: 0,
          records: []
        },
        message: error.message
      }
    }
  }


  public async getGroupById(idGroup: string): Promise<any> {
    try {
      const response: any = await this.__groupsService.getGroupById(idGroup);
      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {},
          message: 'Ocurrio un error al obtener la información del grupo'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {},
        message: error.message
      }
    }
  }


  public async syncGroup(companyId: any, userId: any): Promise<any> {
    try {
      const response: any = await this.__groupsService.syncGroup(companyId, userId);
      await this.__groupsService.syncGroupStatus(companyId, userId, response.code);
      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      }
      return {
        status: false,
        data: JSON.parse(response.content)
      }
    } catch (error) {
      return {
        status: false,
        data: null
      }
    }
  }

  public async createGroup(group: any): Promise<any> {
    try {
      const response: any = await this.__groupsService.createGroup(group);
      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        if (response.code == 'INVALID_PARAM') {
          if (response.content == '"deepness"') {
            return {
              status: false,
              data: {},
              message: 'depth'
            }
          }
          if (response.content == '"name"') {
            return {
              status: false,
              data: {},
              message: 'name'
            }
          }


        }

        if (response.code == 'token') {
          return {
            status: false,
            data: {},
            message: 'token'
          }
        }
        return {
          status: false,
          data: {},
          message: 'general'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {},
        message: error.message
      }
    } finally {
      console.log('finally');
    }
  }

  public async getGroupListChild(idGroupParent: any): Promise<any> {
    try {
      const response: any = await this.__groupsService.getGroupListChild(idGroupParent);
      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {},
          message: 'Ocurrio un error al obtener la lista de grupos asociados a este grupo'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {},
        message: error.message
      }
    }
  }


  public async updateGroup(group: any): Promise<any> {
    try {
      const response: any = await this.__groupsService.updateGroup(group);
      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {},
          message: 'Ocurrio un error al actualizar el grupo'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {},
        message: error.message
      }
    }
  }


  public async getAccessGroup(): Promise<any> {
    try {
      let response: any;
      response = await this.__groupsService.getAllGroupsAccess();

      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {
            page: 0,
            pages: 1,
            count: 0,
            total: 0,
            records: []
          },
          message: 'Ocurrio un error al obtener la lista de grupos'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {
          page: 0,
          pages: 1,
          count: 0,
          total: 0,
          records: []
        },
        message: error.message
      }
    }
  }


  public async getUserGroup(): Promise<any> {
    try {
      let response: any;
      response = await this.__groupsService.getAllUsersGroup();

      if (response.code == 'SUCCESS') {
        return {
          status: true,
          data: JSON.parse(response.content)
        }
      } else {
        return {
          status: false,
          data: {
            page: 0,
            pages: 1,
            count: 0,
            total: 0,
            records: []
          },
          message: 'Ocurrio un error al obtener la lista de grupos'
        }
      }
    } catch (error) {
      return {
        status: false,
        data: {
          page: 0,
          pages: 1,
          count: 0,
          total: 0,
          records: []
        },
        message: error.message
      }
    }
  }


}
